var map = {
	"../components/+account/account.module.ngfactory": [
		"1Q7z",
		0,
		4
	],
	"../components/+restaurant/restaurant.module.ngfactory": [
		"lhMM",
		0,
		1
	],
	"../components/+search_results/search_results.module.ngfactory": [
		"fdvP",
		0,
		2
	],
	"./+checkout/checkout.module.ngfactory": [
		"IWgm",
		0,
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "SfPD";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./$$_lazy_route_resource lazy
// module id = SfPD
// module chunks = 5